<template>
  <v-layout>
    <v-flex>
      <!-- <v-subheader>Weight</v-subheader> -->
      <v-card flat>
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">Units</h3>
            <div>Set your prefered units of measurement for logging workouts, weight and more</div>
            <v-radio-group v-model="weight" :mandatory="false">
              <v-radio color="secondary" label="kgs" value="kgs"></v-radio>
              <v-radio color="secondary" label="lbs" value="lbs"></v-radio>
            </v-radio-group>
            <v-divider></v-divider>
            <v-radio-group v-model="length" :mandatory="false">
              <v-radio color="secondary" label="cm" value="cm"></v-radio>
              <v-radio color="secondary" label="inches" value="inches"></v-radio>
            </v-radio-group>
          </div>
        </v-card-title>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data () {
    return {
      weight: '',
      length: ''
    }
  },
  mounted () {
    this.setMeasurementSystem()
  },
  watch: {
    weight (val) {
      var localMeasureSystem = JSON.parse(localStorage.getItem('measureSystem'))
      localMeasureSystem.weight = this.weight
      localStorage.setItem('measureSystem', JSON.stringify(localMeasureSystem))
    },
    length (val) {
      var localMeasureSystem = JSON.parse(localStorage.getItem('measureSystem'))
      localMeasureSystem.length = this.length
      localStorage.setItem('measureSystem', JSON.stringify(localMeasureSystem))
    }
  },
  methods: {
    setMeasurementSystem: function () {
      if (!localStorage.getItem('measureSystem')) {
        var measureSystem = {
          length: 'cm', weight: 'kgs'
        }
        localStorage.setItem('measureSystem', JSON.stringify(measureSystem))
      } else {
        var localMeasureSystem = JSON.parse(localStorage.getItem('measureSystem'))
        this.length = localMeasureSystem.length
        this.weight = localMeasureSystem.weight
      }
    }
  }
}
</script>
<style scoped>
  .list {
    width: 100%;
    padding: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/members/settingsView.vue